var __jsx = React.createElement;
import * as React from 'react';
import styled from 'styled-components';
import { Button, Option, Loader, Select, breakpoint, color, icons, styles as S } from '@bob/design-system';
import { SortType } from '../hooks/useSearchEngine/sort';
export function Sort(_ref) {
  var _ref$engine = _ref.engine,
      ready = _ref$engine.ready,
      query = _ref$engine.query,
      result = _ref$engine.result,
      sort = _ref$engine.sort,
      label = _ref.label;
  var selectedSort = ready ? sort.configSort.filter(function (sortItem) {
    return sortItem.type === query.value.sortType;
  }) : [{
    name: 'Chargement',
    type: SortType.loading
  }];
  return __jsx(Container, null, __jsx(MobileContainer, null, __jsx(Button, {
    iconLeft: __jsx(icons.Sliders, null),
    outlined: true
  }, __jsx(S.copy.TextTag, null, selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort[0].name)), __jsx(SortSelect, {
    sort: sort,
    selectedSort: selectedSort
  })), __jsx(DesktopContainer, null, __jsx(SortWrapper, null, __jsx(S.copy.Text2, null, result.status === 'success' ? result.total : __jsx(Loader, {
    size: 14
  }), "\xA0", label), __jsx(SortSelect, {
    sort: sort,
    selectedSort: selectedSort
  }))));
}

function SortSelect(_ref2) {
  var sort = _ref2.sort,
      selectedSort = _ref2.selectedSort;
  return __jsx(Select, {
    borderless: true,
    onChange: function onChange(selected) {
      sort.sort(selected[0].value);
    },
    placeholder: selectedSort[0].name,
    status: "focused"
  }, sort.configSort.map(function (item) {
    return __jsx(Option, {
      label: item.name,
      value: item.type,
      key: item.type
    }, item.name);
  }));
}

var Container = styled.div.withConfig({
  displayName: "Sort__Container",
  componentId: "sc-1bh2h9z-0"
})(["margin-left:3px;", "{color:", ";display:inline-block;}@media not screen and (", "){", "{margin:0px;}", "{display:none;}}"], S.copy.TextTag, color.GRAY_1, breakpoint.MOBILE_M, S.button.Text, S.copy.TextTag);
var MobileContainer = styled.div.withConfig({
  displayName: "Sort__MobileContainer",
  componentId: "sc-1bh2h9z-1"
})(["display:none;position:relative;", "{pointer-events:none;position:relative;background-color:", ";}", "{position:absolute;top:0px;left:0px;border:0px;width:100%;", "{opacity:0;}", "{z-index:2;}}@media not screen and (", "){display:block;}"], Button, color.SAND_1, Select, S.form.select.Button, S.form.select.ResponsiveDrawer, breakpoint.TABLET);
var DesktopContainer = styled.div.withConfig({
  displayName: "Sort__DesktopContainer",
  componentId: "sc-1bh2h9z-2"
})(["display:block;", "{position:relative;top:-2px;}@media not screen and (", "){display:none;}"], S.copy.Text2, breakpoint.TABLET);
var SortWrapper = styled.div.withConfig({
  displayName: "Sort__SortWrapper",
  componentId: "sc-1bh2h9z-3"
})(["align-items:center;display:flex;justify-content:flex-end;margin-bottom:10px;position:relative;z-index:2;", "{margin-left:8px;}", "{display:inline;margin-right:4px;}"], Select, Loader);